module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-wall', {
    attrs: {
      "backImg": _vm.backImg
    }
  }, [_c('p', {
    slot: "title"
  }, [_vm._v("公司介绍")]), _vm._v(" "), _c('div', {
    staticClass: "intro-content"
  }, [_c('h3', {
    staticClass: "intro-title"
  }, [_vm._v("北京绿汽科技有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("北京绿汽科技有限公司有着丰富的汽车 、互联网及金融行业经验团队，在围绕着汽车产业开展业务的过程中推出了汽车金融类产品，迅速打开局面获取营业数据、专业、强大的执行团队的基础上，做出了更具前瞻性的汽车金融类产品。而北京绿汽科技有限公司拥有独立研发并拥有独立知识产权系统及风险控制体系AI智能系统，目前已合作润东、维辰、金阳光、远通等经销商集团共700余家4S店，利用本系统可完全解决经销商集团4S店开展二手车业务的痛点，迅速占领市场并与同业展开紧密优质的合作。")]), _vm._v(" "), _c('div', {
    staticClass: "intro-imgs"
  }, [_c('div', {
    staticClass: "intro-check"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/image-1.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro-imgs-cover"
  }, [_vm._v("查估设备")])]), _vm._v(" "), _c('div', {
    staticClass: "intro-work"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/image-2.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro-imgs-cover"
  }, [_vm._v("查估作业")])])]), _vm._v(" "), _c('div', {
    staticClass: "intro-workers"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/image-3.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro-imgs-cover"
  }, [_vm._v("门店展示")])]), _vm._v(" "), _c('p', [_vm._v("线下店面")]), _vm._v(" "), _c('p', {
    staticClass: "intro-content-text"
  }, [_vm._v(" 截至2016年，已发展9家线下直营门店与6家加盟店，包含：直营门店（徐州、南通、临沂、湖州、嘉兴、淮安、淄博、威海、泰安）。加盟店（济南、阜阳、西安、济宁、瑞安、盐城）。自2015年4Q至今，评估超过6万余台实车，均为完整车况（影像、结构、OBD等）及从收购到交易全过程掌握最高价值数据，远程查估服务已遍及700家以上4S店、金融机构及半数以上第三方平台。同时也积极拓展全国各省份SP代理及直营/加盟店。")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6970c10a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/Intro.vue
// module id = 202
// module chunks = 1